<template>
<svg viewBox="0 0 130 130" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-psm-time-full`]" width="1em" height="1em" v-bind="$attrs"><path d="M56.0002351,0 C25.078405,0 0,25.078405 0,56.0002351 C0,86.921595 25.0661793,112 56.0002351,112 C86.9344477,112 112,86.9344477 112,56.0002351 C112,25.078405 86.9344477,0 56.0002351,0 Z M71.1062732,63 L54.8943773,63 C51.6415892,63 49,60.3952108 49,57.1871448 L49,26.8133364 C49,23.6052704 51.6415892,21 54.8943773,21 C58.1471654,21 60.7882667,23.6052704 60.7882667,26.8133364 L60.7882667,51.3869615 L71.1062732,51.3869615 C74.3590613,51.3869615 77,53.9915903 77,57.1996563 C77,60.4077223 74.3590613,63 71.1062732,63 Z" transform="translate(9 9)" :fill="useCurrentColor ? 'currentColor' : '#1BA8AF'" fill-rule="evenodd"/></svg>
</template>
<script>

export default {
  name: 'IconPsmTimeFull',
  props: {
    prefix: {
        type: String,
        default: 'psm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
